// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607280146/js/" + chunkId + "." + {"44":"38684746","225":"0a79fb03","481":"2e2bb933","486":"00943552","770":"9627f995"}[chunkId] + ".0.18718861716001567.chunk.js";
};